import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import TextField from 'material-ui/TextField';
import Typography from 'material-ui/Typography'
import HelpIcon from "../../Icons/HelpIcon";
import ArrowToolTip from "../../common/ArrowToolTip";

const styles = () => ({
  entry: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  title: {
    fontSize: "11px",
    fontWeight: "bold",
    marginBottom: "10px",
  },

  tooltip: {
    marginLeft: "2px",
    marginBottom: "11px",
  },

  newLabel: {
    fontWeight: "bold",
    fontSize: "10px",
    background: "#FFC62B",
    color: "#FFFFFF",
    padding: "3px 6px",
    marginLeft: "5px",
    whiteSpace: "nowrap",
    borderRadius: "3px",
    marginBottom: "10px",
  },
});

class KeywordSearchControl extends React.Component {
  // 複数のキーワード検索の種類があるので、それぞれに対応できるように抽象度を高めに記載しています。
  render() {
    const { classes, typeName, placeholder, disabled, tooltipText, isNew, toolTipPlacement } = this.props;

    // "company"等の文字列が入り、"company_keyword"等になる
    const includeType = this.props.typeKey + "_keyword";

    return (
      <div style={this.props.style}>
        <div className={classes.entry}>
          <Typography
            variant="subheading"
            className={classes.title}
            style={{ color: disabled ? '#B1B3B9' : '#181819' }}
          >
            {typeName}
          </Typography>
          {tooltipText && (
            <div className={classes.tooltip}>
              <ArrowToolTip
                text={tooltipText}
                tooltipMaxWidth={"200"}
                placement={toolTipPlacement}
              >
                <HelpIcon
                  width={12}
                  height={12}
                  color="#71737B"
                />
              </ArrowToolTip>
            </div>
          )}
          {isNew && (
            <div className={classes.newLabel}>NEW</div>
          )}
        </div>
        <TextField
          id={includeType}
          type={includeType}
          placeholder={placeholder}
          value={disabled ? "" : this.props.keyword}
          onChange={(e) => !disabled && this.props.handleChange(e, includeType)}
          InputProps={{
            disableUnderline: true,
          }}
          fullWidth
        />
        {this.props.children}
      </div>
    )
  }
}

KeywordSearchControl.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  typeName: PropTypes.string.isRequired,
  typeKey: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  keyword: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  tooltipText: PropTypes.string,
  isNew: PropTypes.bool,
  toolTipPlacement: PropTypes.string,
  children: PropTypes.node,
};

KeywordSearchControl.defaultProps = {
  tooltipText: null,
  isNew: false,
  toolTipPlacement: 'top',
}

export default withStyles(styles)(KeywordSearchControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/KeywordSearchControl.jsx